/**
 * useTheme Hook - Applies dark mode based on user's settings.
 * Syncs with StoreProvider theme state.
 */

import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useStore } from "@/store";

export const useTheme = () => {
  const { user } = useAuth();
  const { theme } = useStore();

  useEffect(() => {
    if (!user) return;

    // Apply theme based on StoreProvider state
    if (theme === 'dark') {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [user, theme]);
};
